import { DataList } from '@/Core/UI/DataList'

export const DefaultTemplate = ({ listContext }) => {
    return <DataList dataSource={listContext?.data ?? []} />
}
